import QuestionList from './QuestionList/QuestionList.store';
import Question from './Question/Question.store';

export default {
  namespaced: true,
  modules: {
    QuestionList,
    Question,
  },
};
